<template>
  <div class="login-panel">
    <div class="container-fluid">
      <div class="row card-wrap">
        <div class="col-md-4">
          <div class="card">

            <div class="card-body" v-if="isLoginMode">
              <h4 class="card-title">
                User Login
              </h4>
              <form @submit.prevent="submit" autocomplete="off">
                <div class="clearfix">
                  <mdb-input placeholder="Email / Mobile No. / Login ID" v-model="form.login_name" autocomplete="off"/>
                  <transition name="slide-down">
                    <div class="clearfix" v-if="loginIDisMobile">
                      <select class="custom-select" v-model="form.prefix">
                        <option selected value="852">+852</option>
                        <option value="853">+853</option>
                        <option value="86">+86</option>
                      </select>
                    </div>
                  </transition>
                  <mdb-input type="password" label="Password" v-model="form.pwd" autocomplete="new-password"/>
                </div>
                <div class="text-center">
                  <mdb-btn block v-if="!loadingFlag" type="submit" outline="success">Login</mdb-btn>
                  <mdb-btn block v-if="loadingFlag" outline="success">Loading...</mdb-btn>
                </div>
                <div class="clearfix">
                  <googleBtn></googleBtn>
                </div>
                <zoho-login-button></zoho-login-button>
                <div class="text-center" v-if="enablePWD">
                  <a class="reset-link" @click="switchMode('reset')">RESET PASSWORD</a>
                </div>
              </form>
            </div>

            <div class="card-body" v-if="isResetMode">
              <h4 class="card-title">Reset Password</h4>
              <form @submit.prevent="resetPWD" autocomplete="off">
                <fieldset :disabled="loadingFlag">
                  <div class="clearfix">
                    <mdb-input label="Email / Mobile No." v-model="resetForm.mobile" autocomplete="off"
                              :invalid-feedback="errors.mobile || errors.email" :validation="!!(errors.mobile) || !!(errors.email)"></mdb-input>
                    <transition name="slide-down">
                      <select v-if="isMobile" class="browser-default custom-select" v-model="resetForm.areaCode">
                        <option value="+852" selected>852</option>
                        <option value="+853">853</option>
                        <option value="+86">86</option>
                      </select>
                    </transition>
                    <mdb-input label="Verification code" v-model="resetForm.vcode" autocomplete="off"
                              :invalid-feedback="errors.vcode" :validation="!!(errors.vcode)"></mdb-input>
                    <mdb-input type="password" label="New password" v-model="resetForm.pwd" autocomplete="new-password"
                              :invalid-feedback="errors.pwd" :validation="!!(errors.pwd)"></mdb-input>
                    <mdb-input type="password"  label="Confirm your password" v-model="resetForm.cpwd" autocomplete="off"
                              :invalid-feedback="errors.cpwd" :validation="!!(errors.cpwd)"></mdb-input>
                  </div>
                  <div class="text-center">
                    <mdb-btn block @click="sendVcode" type="button" outline="secondary">Send verification code</mdb-btn>
                    <mdb-btn block @click="resetPWD" v-if="resetForm.vcode" type="button" outline="success">Reset password</mdb-btn>
                    <mdb-btn block @click="switchMode('login')" type="button" outline="info">Cancel</mdb-btn>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mdbInput from "mdbvue/src/components/Forms/Input";
import mdbBtn from "mdbvue/src/components/Components/Button";
import userService, {ValidateError} from "../Services/UserService";
import googleBtn from "./GoogleSingIn"
import ZohoLoginButton from "../components/ZohoLoginButton.vue";

const {EventBus} = require("../Bus.js");

const ENABLE_RESET_PWD = window.RESET_PWD_FEATURE || false;
const MODE_LOGIN = 'login';
const MODE_RESET = 'reset';


export default {
  data() {
    return {
      loadingFlag: false,
      mode: MODE_LOGIN,
      form: {
        prefix: "852",
        login_name: "",
        pwd: ""
      },
      resetForm:{
        vcode: "",
        pwd: "",
        mobile: "",
        cpwd: "",
        areaCode: "+852",
      },
      errors: {},
    };
  },

  computed: {
    isLoginMode() {
      return this.mode === MODE_LOGIN;
    },
    isResetMode() {
      return this.mode === MODE_RESET;
    },
    enablePWD() {
      return ENABLE_RESET_PWD;
    },
    loginIDisMobile() {
      return /^([0-9]{8}|[0-9]{11})$/i.test(this.form.login_name)
    },
    isMobile() {
      return /^([0-9]{8}|[0-9]{11})$/i.test(this.resetForm.mobile)
    },
  },

  components: {
    mdbInput,
    mdbBtn,
    googleBtn,
    ZohoLoginButton,
  },

  mounted() {
    this.tryReLogin();
  },

  methods: {
    switchMode(mode) {
      this.mode = mode;
      if( mode == 'login') {
        Object.keys(this.resetForm).forEach((item)=>{
          this.resetForm[item] = '';
        });
        this.resetForm.areaCode = "+852";
      }
    },
    tryReLogin() {
      const user = new userService(),
          ref = this.$route.query.ref || null;
      user.refresh().then(() => {
        EventBus.dispatchUserLogin();
        if (ref) {
          this.$router.push({
            path: ref
          });
          return;
        }
        this.$router.push({
          path: '/'
        });
      })
    },
    submit() {
      if (this.loadingFlag) {
        return;
      }
      this.loadingFlag = true;
      const user = new userService(),
          ref = this.$route.query.ref || null;


      const loginName = this.loginIDisMobile ? `${this.form.prefix}${this.form.login_name}` : `${this.form.login_name}`;

      user
          .login(loginName, this.form.pwd)
          .then(() => {
            EventBus.dispatchUserLogin();
            if (ref) {
              this.$router.push({
                path: ref
              });
              return;
            }
            this.$router.push({
              path: '/'
            });
          })
          .finally(() => {
            this.loadingFlag = false;
            this.form.login_name = "";
            this.form.pwd = "";
          });
    },
    sendVcode() {
      const service = new userService();
      this.loadingFlag = true;
      let params = {
        mobile: `${this.resetForm.areaCode}${this.resetForm.mobile}`
      };
      if (!this.isMobile) {
        params = {
          email: this.resetForm.mobile,
        }
      }

      return service.sendVCode(params)
          .then(() => {
            let msg = `An email containing a verification code has been sent to the email address registered by you. Please check your inbox.\n驗證碼已發送至您註冊的郵箱，請查收郵件。`;
            if (this.isMobile) {
              msg = `A verification code has been sent via WhatsApp to the phone number registered by you. Please check for the message.\n驗證碼已透過WhatsApp發送至您註冊的手機號碼，請查收。`;
            }
            alert(msg);
          })
          .catch((error) => {
            console.log(error);

            if (error instanceof ValidateError) {
              const msgs = error.getValidate();
              this.errors = {
                ...msgs,
              }
              return Promise.reject(error);
            }
            if (error instanceof Error) {
              this.errors = {
                mobile: error.message,
              }
              return Promise.reject(error);
            }
            return Promise.reject(error);
          })
          .finally(() => {
            this.loadingFlag = false;
          });
    },
    resetPWD() {
      if (this.resetForm.pwd && this.resetForm.pwd != this.resetForm.cpwd) {
        this.errors = {
          cpwd: "Passwords don't match",
        };
        return;
      }
      const service = new userService();
      this.loadingFlag = true;

      let params = {
        mobile: `${this.resetForm.areaCode}${this.resetForm.mobile}`
      };
      if (!this.isMobile) {
        params = {
          email: this.resetForm.mobile,
        }
      }

      params = {
        ...params,
        pwd: this.resetForm.pwd,
        vcode: this.resetForm.vcode,
      }

      return service.resetPwd(params)
          .then(() => {
            this.errors = {};
            this.resetForm = {};
            this.switchMode(MODE_LOGIN);
          })
          .catch((error) => {
            if (error instanceof ValidateError) {
              const msgs = error.getValidate();
              this.errors = {
                ...msgs,
              }
              return Promise.reject(error);
            }
            if (error instanceof Error) {
              this.errors = {
                mobile: error.message,
              }
              return Promise.reject(error);
            }

            return Promise.reject(error);
          })
          .finally(() => {
            this.loadingFlag = false;
          });
    }
  }
};
</script>
